import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/map';

@Injectable()
export class SharedService {
  settings;
  playersCol;
  playersObs;
  players;
  clock;
  adminNames;
  constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, private router: Router){
    const that = this;
    this.clock = Observable.interval(1000).map(tick => new Date()).share();
    const settingsDoc = this.afs.doc('settings/' + 'c3AIhlbEFfjGjzJU6WY3');
    settingsDoc.valueChanges().subscribe(settings => {
      that.settings = settings;
    });
    this.afs.collection('adminNames').valueChanges().subscribe(adminNames => {
      that.adminNames = adminNames;
    });
    this.playersCol = this.afs.collection('players');
    this.playersObs = this.playersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
    this.playersObs.subscribe(players => {
      that.players = _.sortBy(players, function(player) {
        if (!player.order) {
          return 1000;
        } else {
          return player.order;
        }
      });
    });
  }

  login() {
    const that = this;
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(function() {
      that.router.navigate(['']);
    });
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  getCurrentPlayer() {
    return _.find(this.players, function(player) {
      return player.currentPlayer;
    });
  }

  getMaxBidCurrentPlayer() {
    const currentPlayer = this.getCurrentPlayer();
    if (currentPlayer && currentPlayer.bids.length > 0) {
      return _.maxBy(currentPlayer.bids, function(bid) {
        return bid.amount;
      });
    }
    return null;
  }

  getMinimumNextBid() {
    const currentMax = this.getMaxBidCurrentPlayer();
    if (!currentMax) {
      return 50;
    } else {
      const valuePreRound = Math.min(currentMax.amount * 1.05, currentMax.amount + 100);
      const x = 20 * Math.floor(valuePreRound / 20);
      const y = valuePreRound % 20;
      return y === 0 ? x : x + 20;
    }
  }

  getCurrentPlayerTimeLeft(clock) {
    const player = this.getCurrentPlayer();
    if (!this.settings || !player) { return 0; }
    const endTime = this.getEndTime(player) ;
    return endTime - clock;
  }

  getCurrentPlayerTimeLeftDisplay(clock) {
    const timeLeft = this.getCurrentPlayerTimeLeft(clock);
    return timeLeft > 0 ? Math.floor(timeLeft / 60000) + ':' +
    Math.floor((timeLeft) % 60000 / 1000) : 'Player Bidding Ended';
  }

  getEndTime(player) {
    const start = _.find(player.times, function(time) {
      return time.type === 'start';
    });
    if (!start) { return null; }
    const startBasedEndTime = start.time + this.getPausedTime(player) + this.settings.bidTime * 1000;
    const bidBasedEndTime = this.getEndTimeOfBasedOnLastBid(player);
    return Math.max(startBasedEndTime, bidBasedEndTime);
  }

  getEndTimeOfBasedOnLastBid(player) {
    const bidTimes = _.filter(player.times, function(time) {
      return time.type === 'bid';
    });
    if (!bidTimes.length) { return 0 }
    const lastBidTime = _.maxBy(bidTimes, function(time) {
      return time.time;
    });
    const pausedTime = this.getPausedTime(player, lastBidTime.time);
    return lastBidTime.time + pausedTime + this.settings.bidTimeExtension * 1000;
  }

  getPausedTime(player, startTime = null) {
    const pauses = _.orderBy(_.filter(player.times, function(time) {
      if (startTime) {
        return (time.type === 'pause' || time.type === 'resume') && time.time > startTime;
      } else {
        return time.type === 'pause' || time.type === 'resume';
      }
    }), 'time', 'asc');
    if (pauses.length % 2 === 1) {
      pauses.push({time: new Date().getTime()});
    }
    let pausedTime = 0;
    for (let x = 0; x < pauses.length; x += 2) {
      pausedTime += pauses[x + 1].time - pauses[x].time;
    }
    return pausedTime;
  }

  pause() {
    const that = this;
    this.getCurrentPlayer().times.push(
      { type: 'pause',
        time: new Date().getTime()
      });
    this.playersCol.doc(that.getCurrentPlayer().id).update(that.getCurrentPlayer());
  }

  isPaused() {
    const player = this.getCurrentPlayer();
    if (!player) { return false; }
    const pauses = _.filter(player.times, function(time) {
      return time.type === 'pause' || time.type === 'resume';
    });
    if (pauses.length % 2 === 1) {
      return true;
    }
    return false;
  }

  resume() {
    const that = this;
    this.getCurrentPlayer().times.push(
      { type: 'resume',
        time: new Date().getTime()
      });
    this.playersCol.doc(that.getCurrentPlayer().id).update(that.getCurrentPlayer());
  }

  start() {
    this.players[0].currentPlayer = true;
    this.players[0].times.push({
      type: 'start',
      time: new Date().getTime()
    });
    this.playersCol.doc(this.players[0].id).update(this.players[0]);
  }

  nextPlayer() {
    const that = this;
    for (let x = 0; x < this.players.length; x++) {
      if (that.players[x].currentPlayer) {
        that.players[x].currentPlayer = false;
        that.playersCol.doc(this.players[x].id).update(that.players[x]).then(function() {
          if (x < that.players.length - 1) {
            that.players[x + 1].currentPlayer = true;
            that.players[x + 1].times.push({
              type: 'start',
              time: new Date().getTime()
            });
            that.playersCol.doc(that.players[x + 1].id).update(that.players[x + 1]);
          }
        });
      }
    }
  }

  addPlayer(name, img, order) {
    this.playersCol.add({
      bids: [],
      currentPlayer: false,
      image: img,
      name: name,
      order: order,
      times: []
    });
  }

  updatePlayer(player) {
    this.playersCol.doc(player.id).update(player);
  }

  deletePlayer(player) {
    this.playersCol.doc(player.id).delete();
  }

  isAdmin() {
    const that = this;
    if (!that.adminNames) { return false; }
    return !!_.find(that.adminNames, function(adminName) {
      return adminName.name === that.afAuth.auth.currentUser.displayName;
    });
  }

  overrideBid(amount) {
    const player = this.getCurrentPlayer();
    const time = new Date().getTime();
    player.bids = [{
          amount: amount,
          bidder: this.afAuth.auth.currentUser.displayName
        }];
    player.times.push({
      time: time - 1,
      type: 'resume'
    });
    player.times.push({
          time: time,
          type: 'bid'
        });
    player.times.push({
          time: time + 1,
          type: 'pause'
        });
    this.playersCol.doc(player.id).update(player);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts